module.exports = __webpack_public_path__ + "img/products_big_can_ultimate.3d1c2e2b.png";